import React from 'react';
import { useSelector } from 'react-redux';

import TeammateSuggestionsCalendarConnected from './TeammateSuggestionsCalendarConnected/TeammateSuggestionsCalendarConnected';
import SuggestionsCalendarDisconnected from '../SuggestionsCalendarDisconnected/SuggestionsCalendarDisconnected';

import './AddTeammateSuggestionsSection.scss';

type Props = {
  includeOrgMembers?: boolean;
  formValues: {};
  onSuggestedMeetingClick: Function;
};

function AddTeammateSuggestionsSection({ includeOrgMembers = true, formValues, onSuggestedMeetingClick }: Props) {
  const isCalendarConnected = useSelector(state =>
    Boolean(state.data_sources.find(ds => ds.isCalendar && ds.connected))
  );

  return (
    <div className="add-teammate-suggestions-section mt-4">
      {isCalendarConnected ? (
        <TeammateSuggestionsCalendarConnected
          includeOrgMembers={includeOrgMembers}
          formValues={formValues}
          onSuggestedMeetingClick={onSuggestedMeetingClick}
        />
      ) : (
        <SuggestionsCalendarDisconnected />
      )}
    </div>
  );
}

export default AddTeammateSuggestionsSection;
